import {Component, Input} from 'ng-metadata/core';
import './icon.component.scss';

/**
 * @ngdoc directive
 * @name mwIcon
 * @module mw.components.icon
 *
 * @description
 * `<mw-icon>` is a component used to display icons.
 *
 * @param {string} [svg-src] - URL (or expression) used to load, cache, and display an external SVG.
 * @param {string} [svg-icon] - Icon name used for lookup of in the icon registry.
 * @param {string} [aria-label] - ARIA text.
 * @param {string} [size] - Size of the icon. Supported values include 'sm' and 'xs'.
 * @usage
 * <hljs hljs-language="html">
 *   <mw-icon svg-icon="meltwater:dashboard" aria-label="dashboard"></mw-icon>
 *   <mw-icon svg-src="icons/rainbow.svg" aria-label="rainbow" size="sm"></mw-icon>
 *   <mw-icon svg-src="{{ $ctrl.getMyIcon() }}" aria-label="my icon"></mw-icon>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-icon',
    template: `
        <md-icon ng-if="::$ctrl.svgIcon" md-svg-icon="{{ $ctrl.svgIcon }}" aria-label="{{ $ctrl.ariaLabel }}" class="mw-icon {{ $ctrl.getSizeClass() }}"></md-icon>
        <md-icon ng-if="::$ctrl.svgSrc" md-svg-src="{{ $ctrl.svgSrc }}" aria-label="{{ $ctrl.ariaLabel }}" class="mw-icon {{ $ctrl.getSizeClass() }}"></md-icon>
    `
})
export class IconComponent {

    @Input('@') svgIcon: string;
    @Input('@') svgSrc: string;
    @Input('@') ariaLabel: string;
    @Input('@') size: string = '';

    constructor() {
        'ngInject';
    }

    getSizeClass() {
        if (this.size.length > 0) return `mw-icon--${this.size}`;
        return '';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/icon/icon.component.ts